"use strict";
/**
 * @packageDocumentation
 * @module CTypeMetadata
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("@kiltprotocol/utils");
const CType_utils_1 = tslib_1.__importDefault(require("./CType.utils"));
const CTypeSchema_1 = require("./CTypeSchema");
class CTypeMetadata {
    /**
     *  Instantiates a new CTypeMetadata.
     *
     * @param metadata [[ICTypeMetadata]] that is to be instantiated.
     * @throws [[ERROR_OBJECT_MALFORMED]] when metadata is not verifiable with the MetadataModel.
     * @returns The verified and instantiated [[CTypeMetadata]].
     */
    constructor(metadata) {
        if (!CType_utils_1.default.verifySchema(metadata, CTypeSchema_1.MetadataModel)) {
            throw utils_1.SDKErrors.ERROR_OBJECT_MALFORMED();
        }
        this.metadata = metadata.metadata;
        this.ctypeHash = metadata.ctypeHash;
    }
}
exports.default = CTypeMetadata;
